import React, { useEffect, useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { useTheme } from '@emotion/react'
import UseMAcRequest from './UseMAcRequest'
import MacAuthentication from './MacAuthentication'
import MacManagement from './MacManagement'
import { useSearchParams } from 'react-router-dom'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { macDetailTabIds } from '../../GeneralSettings/GSConstants'
import WebCargoMACMgt from './WebCargoMACMgt'

const MacDetailes = ({ loginData }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || '')
  const [allTabs, setAllTabs] = useState([])
  //   const macTabNames = ['User Mac Request', 'MAC AUTHENTICATION', 'MAC MANAGEMENT']
  const macTabNames = [{ name: 'User Mac Request', JobID: 28 }, { name: 'MAC AUTHENTICATION', JobID: 29 }, { name: 'MAC MANAGEMENT', JobID: 30 }, { name: 'Web Cargo MAC Mgt', JobID: 31 }]

  const theme = useTheme()
  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);

    if (selectedTab === '') {
      const newData = macTabNames.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null)
      goToTabs(newData?.[0]?.JobID)
    }

    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
    } else {
      setAllTabs([])
    }
  }, [searchParams, selectedTab]);
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }

  // const handleMacTabs = (event, value) => {
  //     setMacTabs(value)
  //     // setTableHeader(tableHeaders[value])
  // }
  const getMacDetailesTab = (typeId, label) => {
    switch (typeId) {
      case 28:
        return <UseMAcRequest loginData={loginData} />
      case 29:
        return <MacAuthentication loginData={loginData} />
      case 30:
        return <MacManagement loginData={loginData} />
      case 31:
        return <WebCargoMACMgt loginData={loginData} />
      default:
        return label
    }
  }
  return (
    <>
      <Box className="bookingPageTabContainer">
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              variant="scrollable"
              value={selectedTab}
              onChange={(e, newValue) => goToTabs(newValue)}
              aria-label="bsic tabs example"
              sx={{
                minHeight: 'unset',
                alignItems: 'center',
                '& .MuiTabs-scrollButtons.Mui-disabled': {
                  opacity: 1,
                  width: '25px',
                  height: '25px',
                  borderRadius: '50px',
                  background: 'grey !important',
                  fontSize: '20px',
                  color: 'white !important',
                  marginTop: '0px',
                },
                '& .Mui-disabled': {
                  backgroundColor: 'transparent !important',
                  border: 'none !important',
                  color: 'red',
                },
                '& .MuiTabs-scrollButtons': {
                  opacity: 1,
                  width: '25px',
                  height: '25px',
                  borderRadius: '50px',
                  background: '#0086ff !important',
                  fontSize: '20px',
                  color: 'white !important',
                  marginTop: '0px',
                },
              }}
            >
              {macTabNames.map((reqType, index) => (
                <Tab key={`sender_${reqType.JobID}`} value={reqType.JobID} label={reqType.name} {...macDetailTabIds(reqType.JobID)}
                  sx={{
                    display:
                      findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID', "IsActive") === 1
                        ? 'block'
                        : 'none',
                  }}
                />
              ))}
            </Tabs>
          </Box>
          {macTabNames.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
              style={{
                display:
                  findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID', "IsActive") === 1
                    ? 'block'
                    : 'none',
              }}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getMacDetailesTab(reqType.JobID, reqType.name)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}
export default MacDetailes